import console from './console-compat'

export default {
    install(Vue, options) {
        // Vue.prototype.$alert = (message) => window.alert(message);
        Vue.prototype.$console = console;
    }
}
